import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import illustrationSrc from '../../../assets/images/talisman-hand-progress-indicator.gif';
const TalismanHandProgressIndicator = (props) => {
    return (_jsx("img", { className: props.className, src: illustrationSrc, css: { width: '12.8rem', height: '12.8rem' }, style: props.style }));
};
export default TalismanHandProgressIndicator;
//# sourceMappingURL=TalismanHandProgressIndicator.js.map